import TenantForm from './TenantForm';
export default TenantForm;
